import { OverlayModule } from '@angular/cdk/overlay';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { SharedPipesModule } from 'app/pipes/shared-pipes.module';

import { CdsTooltipModule } from '../cds-tooltip/cds-tooltip.module';
import { KpiComponent } from '../kpi-card/kpi/kpi.component';
import { KpiTooltipComponent } from '../kpi-card/kpi/kpi-tooltip/kpi-tooltip.component';
import { KpiCardComponent } from '../kpi-card/kpi-card.component';
import { KpiTrendIndicatorModule } from '../kpi-trend-indicator/kpi-trend-indicator.module';
import { StatusBadgeModule } from '../status-badge/status-badge.module';

@NgModule({
  declarations: [KpiCardComponent, KpiComponent, KpiTooltipComponent],
  exports: [KpiCardComponent, KpiComponent],
  imports: [
    BrowserModule,
    OverlayModule,
    CdsTooltipModule,
    StatusBadgeModule,
    KpiTrendIndicatorModule,
    SharedPipesModule,
    MatIconModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KpiCardModule {}
